import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { imageType } from '@whelk/services/src/share';

export interface eventParamsInfo {
  msgId?: string;
  botId?: string;
  chatId?: string;
}

export interface FileSliceStore {
  dragUploadFileList: File[]; // 拖拽上传文件列表
  imgMaskVisible: boolean;
  imgMaskUrl: string;
  imgMaskUrlList: string[];
  eventParams: eventParamsInfo;
  filePreview: {
    url: string; // 文件预览的链接
    name: string;
  };
  isFilePreviewAutoOpened: boolean;
  openOnSendFile?: {
    fileID: string;
    fileName: string;
  };
}

export interface ImagePreviewParams {
  url: string;
  urlList?: imageType[];
  isByText?: boolean;
  position?: number;
  eventParams?: eventParamsInfo;
}

const initialState: FileSliceStore = {
  dragUploadFileList: [],
  imgMaskVisible: false,
  imgMaskUrl: '',
  imgMaskUrlList: [],
  eventParams: {},
  filePreview: {
    url: '',
    name: '',
  },
  isFilePreviewAutoOpened: false,
  openOnSendFile: undefined,
};

export const fileSlice = createSlice({
  name: 'audio',
  initialState,
  reducers: {
    clearDragUploadFileList: (state) => {
      return {
        ...state,
        dragUploadFileList: [],
      };
    },
    setDragUploadFileList: (state, action: PayloadAction<File[]>) => {
      return {
        ...state,
        dragUploadFileList: action.payload,
      };
    },
    setFilePreview: (
      state,
      action: PayloadAction<{
        url: string; // 文件预览的链接
        name: string;
      }>,
    ) => {
      return {
        ...state,
        filePreview: action.payload,
      };
    },
    setIsFilePreviewAutoOpened: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        isFilePreviewAutoOpened: action.payload,
      };
    },
    setImgMaskUrl: (state, action: PayloadAction<ImagePreviewParams>) => {
      return {
        ...state,
        imgMaskUrl: action.payload.url,
        imgMaskUrlList: action.payload.urlList?.length
          ? action.payload?.urlList?.map((item) => item.medium)
          : [action.payload.url],
        eventParams: action.payload.eventParams || {},
      };
    },
    setImgMaskVisible: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        imgMaskVisible: action.payload,
      };
    },
    clearImgMask: (state) => {
      return {
        ...state,
        imgMaskUrl: '',
        imgMaskUrlList: [],
      };
    },
    setOpenOnSendFile: (state, action: PayloadAction<{ fileID: string; fileName: string } | undefined>) => {
      return {
        ...state,
        openOnSendFile: action.payload,
      };
    },
  },
});

export const {
  clearDragUploadFileList,
  setDragUploadFileList,
  setFilePreview,
  setIsFilePreviewAutoOpened,
  clearImgMask,
  setImgMaskVisible,
  setImgMaskUrl,
  setOpenOnSendFile,
} = fileSlice.actions;

export default fileSlice.reducer;
